import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props =>
    props.index % 2 === 0 ? props.theme.colors.background.secondary : props.theme.colors.text.inverse};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const PositionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${props => props.theme.spacing.sp16};
  color: ${props => props.theme.colors.text.muted};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin-right: ${props => props.theme.spacing.sp16};
  min-width: 50px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  flex-grow: 1;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Description = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp8};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  align-self: stretch;
  border-radius: ${props => props.theme.primitives.radius.radius1};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  background: ${props => props.theme.colors.background.primary};
  overflow-wrap: anywhere;
`
